import * as React from "react";

import type { PreloadableComponent } from "react-lazy-with-preload";

export interface PreloadableProps<P> {
  preloadWith?: PreloadableComponent<typeof React.Component | React.FC<P>>[];
  preloadOption?: "onmount" | "manual";
}

export const withPreloadable = <P extends object, S extends object>(
  Component: typeof React.Component | React.FC<P>,
) =>
  class WithPreloadable extends React.Component<P & PreloadableProps<P>, S> {
    render() {
      return <Component {...(this.props as P)} />;
    }

    componentDidMount() {
      if (this.props?.preloadOption === "onmount") {
        this.preload();
      }
    }

    public preload() {
      this.props.preloadWith?.forEach((p) => {
        p.preload();
      });
    }
  };
